class LinkTypeService {
    /**
     * Extract informations from a link type
     *
     * @param entityLinkType - Link type pointing to an entity
     * @returns Technical informations about link type
     */
    extractInformationsFromLinkType(entityLinkType) {
        // Mock baseUrl in constructor because we only need uri
        const entityUrl = new URL(entityLinkType.href, 'https://www.mgdis.fr');
        const reference = entityUrl.pathname.split('/').pop();
        const revisionDate = entityUrl.searchParams.get('date');
        return {
            reference: reference?.length ? reference : null,
            revisionDate,
        };
    }
}
export { LinkTypeService };
//# sourceMappingURL=link-type-service.js.map